// src/features/tasks/services/taskEquipment.js
import { apiClient } from '../../../services/api/client';

export const taskEquipmentAPI = {
  // List equipment linked to a task
  listTaskEquipment: (taskId) => 
    apiClient.get(`/api/v1/task-management/tasks/${taskId}/equipment`),

  // Link equipment to a task
  linkEquipmentToTask: (taskId, data) =>
    apiClient.post(`/api/v1/task-management/tasks/${taskId}/equipment`, data),

  // Update an existing equipment link (relation type, notes, rotation config)
  updateTaskEquipment: (taskId, taskEquipmentId, data) =>
    apiClient.patch(`/api/v1/task-management/tasks/${taskId}/equipment/${taskEquipmentId}`, data),

  // Check/uncheck an equipment link for the current task occurrence
  setTaskEquipmentChecked: (taskId, taskEquipmentId, isChecked) =>
    apiClient.patch(`/api/v1/task-management/tasks/${taskId}/equipment/${taskEquipmentId}/check`, { is_checked: isChecked }),

  // Unlink equipment from a task
  unlinkEquipmentFromTask: (taskId, taskEquipmentId) =>
    apiClient.delete(`/api/v1/task-management/tasks/${taskId}/equipment/${taskEquipmentId}`),

  // Get all task-equipment links for the department in one shot
  getDepartmentTaskEquipmentLinks: () =>
    apiClient.get('/api/v1/task-management/tasks/equipment'),
};